/**
 * By default, make no transforms for null types. If you prefer, you could use these transforms to e.g.
 * transform null into a Maybe monad.
 */
const defaultNullFunctions = {
    serialize(input) {
        return input;
    },
    parseValue(raw) {
        return raw;
    },
};
export default defaultNullFunctions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1udWxsLWZ1bmN0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvZGVmYXVsdC1udWxsLWZ1bmN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTs7O0dBR0c7QUFDSCxNQUFNLG9CQUFvQixHQUFrQjtJQUMxQyxTQUFTLENBQUMsS0FBVTtRQUNsQixPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFDRCxVQUFVLENBQUMsR0FBUTtRQUNqQixPQUFPLEdBQUcsQ0FBQztJQUNiLENBQUM7Q0FDRixDQUFDO0FBRUYsZUFBZSxvQkFBb0IsQ0FBQyJ9